<div *ngIf="isLoading" class="loading-container" >
    <div class="loading-background"></div>
    
    <ng-lottie
    class="animation"
    [options]="options"
    (animationCreated)="animationCreated($event)">
  </ng-lottie>
  <p class="message">{{ randomMessage }}</p>
  
  </div>